export default {
    account: 'حساب',
    'export': 'تصدير',
    'export-from-latest-matching': 'تصدير من آخر مطابقة',
    'export-as-excel': 'تصدير إكسل',
    'print-account-statement': 'طباعة كشف حساب',
    'brief': '(مختصر)',
    'view-match-table': 'عرض جدول المُطابقات',
    back: 'رجوع',

    'account-num-or-name': 'رقم أو اسم الحساب',
    'search-within-caption': 'بحث ضمن الشرح',

    'from-date': 'من تاريخ',
    'to-date': 'إلى تاريخ',
    'to': 'إلى',
    'show-all-columns': 'عرض كل الأعمدة',
    
    refresh: 'تحديث',
    'go-to-the-journal-of-entry': 'الانتقال إلى اليومية الخاصة بالقيد',
    match: 'مُطابقة',
    'account-match': 'إلغاء مُطابقة الحساب',
    'account-unmatch': 'مُطابقة الحساب',

    'are-you-sure-you-want-to-account-unmatch': 'هل أنت مُتأكد من إلغاء مُطابقة الحساب ؟',
    'are-you-sure-you-want-to-account-match': 'هل أنت مُتأكد من مُطابقة الحساب ؟',
    
    'currency-balances': 'أرصدة العملات:',
    'more-details': 'مزيد من التفاصيل',
    
    'sum-debit': 'مجموع مدين',
    'sum-credits': 'مجموع دائن',
    'currency-debits': 'عملات مدينة',
    'currency-credits': 'عملات دائنة',
    'currency-equivalent': 'الرصيد بعملة مختلفة',
    
    'select-the-currency-to-display-the-equivalent-value': 'اختر العملة لعرض القيمة المُكافئة',

    today: 'اليوم',
    balance: 'الرصيد:',

    'sum-result-headers': {
        'sum-debits': 'مجموع مدين',
        'sum-credits': 'مجموع دائن',
        balance: 'الرصيد',
        'equivalent-currency': 'عملة مكافئة',
        'currency-equivalent': 'المكافئ بالعملة',
        'currencies-balance': 'أرصدة العملات',
    },

    'sum-currencies-result-headers': {
        'currency-debits': 'عملات مدينة',
        'currency-credits': 'عملات دائنة',
    },

    headers: {
        balance: 'الرصيد',
        debit: 'المدين',
        credit: 'الدائن',
        note: 'البيان',
        'currency-debit': 'عملة مدينة',
        'currency-credit': 'عملة دائنة',
        currency: 'العملة',
        'currency-price': 'السعر',
        'currency-balances': 'أرصدة العملات',
        'paper-document-no': 'م.الورقي',
        date: 'التاريخ',
    },
}